<template>
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path
      d="M13.5 4.5L6 12L2.5 8.5"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class CheckIcon extends Vue {}
</script>
